import React, { useState } from "react";
import { Download } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import ReportExportBlock from "./ReportExportBlock";

export default function GroupReportButton({ groupId }) {
  const [open, setOpen] = useState(false);
  return <Dialog open={open} onOpenChange={setOpen}>
    <DialogTrigger asChild>
      <Button type="button" variant="outline" size="sm" className="ml-3 shrink-0 gap-1.5 border-emerald-200 bg-white text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800" aria-label={`Выгрузить отчёт группы ${groupId}`}>
        <Download className="h-3.5 w-3.5" aria-hidden="true" />Отчёт
      </Button>
    </DialogTrigger>
    <DialogContent className="w-[calc(100vw_-_2rem)] max-w-md">
      <DialogHeader>
        <DialogTitle>Отчёт группы {groupId}</DialogTitle>
        <DialogDescription>Успешные задания bfs-group-{groupId} за выбранные даты по МСК. Включая активные и неактивные проекты.</DialogDescription>
      </DialogHeader>
      <ReportExportBlock groupId={groupId} compact className="w-fit max-w-full" />
    </DialogContent>
  </Dialog>;
}
